<template>
  <div class="login">
    <div v-if="isMobileApp" class="mobile-overlay"></div>
    <!-- VK SSO Loader -->
    <div v-if="(isVKSSO || isYandexSSO) && isAuthSSO" class="sso-loader">
      <div class="sso-loader__container">
        <div class="sso-loader__logo">
          <img :src="logo" alt="Scount" />
        </div>
        <div class="sso-loader__spinner">
          <Loader size="32" />
        </div>
        <div class="sso-loader__text">
          <p>Загрузка...</p>
        </div>
      </div>
    </div>

    <!-- Обычная форма логина -->
    <div v-else class="login__container">
      <div class="login__main">
        <div class="login__header login__header_default">
          <div class="header__row">
            <div class="header__group">
              <div class="header__item header__logo">
                <a href="/"><img :src="logo" alt="Scount"></a>
              </div>
            </div>
          </div>
        </div>
        <div class="login__content">
          <div class="main__loader" v-if="sending || sendingCode || (step === 'start' && providersAuthStatus === null)">
            <Loader size="24" />
          </div>

          <!-- Начальный шаг -->
          <div v-if="step === 'start'">
            <div class="main__title" v-if="isExtendedAuthStart && providersAuthStatus !== null && providersAuthStatus !== 0">Вход в кабинет участника</div>
            <div v-if="providersAuthStatus === 0" class="main__error">
              <Alert
                title="Ошибка загрузки"
                text="Не удалось загрузить способы авторизации. Пожалуйста, обновите страницу."
                state="error"
                no-action
              ></Alert>
            </div>
            <div class="main__form" v-if="providersAuthStatus !== null && providersAuthStatus !== 0">
              <div v-if="isExtendedAuthStart">
                <div v-if="hasSSOProvider || hasVKProvider || hasYandexProvider" class="form__sso">
                  <Alert
                    v-if="ssoError || vkError || yandexError"
                title="Что-то пошло не так"
                text="Пожалуйста, попробуйте ещё раз."
                state="error"
                no-action
              ></Alert>

              <Button
                    v-if="hasSSOProvider"
                variant="secondary"
                size="lg"
                text="Войти с RR"
                mobile
                wide
                class="form__sso-button"
                @click="onSSO"
              >
                <slot name="before">
                  <span class="rr-button__icon rr-button__icon_auto">
                    <img src="/img/sso/RR.svg" width="20" height="20" alt="RR" />
                  </span>
                </slot>
              </Button>

                  <Button
                    v-if="hasVKProvider"
                    variant="secondary"
                    size="lg"
                    text="VK ID"
                    mobile
                    wide
                    class="form__sso-button"
                    @click="onVK"
                  >
                    <slot name="before">
                      <span class="rr-button__icon rr-button__icon_auto">
                        <img src="/img/sso/VK.svg" width="20" height="20" alt="VK" />
                      </span>
                    </slot>
                  </Button>

                  <Button
                    v-if="hasYandexProvider"
                    variant="secondary"
                    size="lg"
                    text="Яндекс"
                    mobile
                    wide
                    class="form__sso-button"
                    @click="onYandex"
                  >
                    <slot name="before">
                      <span class="rr-button__icon rr-button__icon_auto">
                        <img src="/img/sso/Yandex.svg" width="20" height="20" alt="Яндекс" />
                      </span>
                    </slot>
                  </Button>

                  <div v-if="hasEmailProvider" class="form__or">
                <div class="or__line"></div>
                <div class="or__text">или</div>
                <div class="or__line"></div>
              </div>
            </div>
                <div v-if="hasEmailProvider" class="form__email">
            <div class="form__label">Электронная почта</div>
            <div class="form__inputs">
              <Input
                size="md"
                placeholder="your@email.com"
                name="email"
                type="email"
                id="login-email"
                v-model.trim="email"
                mobile
                :state="emailError ? 'error' : null"
                @keydown="onEmailKeydown"
              />
                    <Button
                      variant="primary"
                      size="md"
                      text="Получить код"
                      mobile
                      @click="onGetCode"
                      :disabled="emailError"
                    ></Button>
                  </div>
                  <div class="email-errors">
                    <div class="color-danger" v-if="emailError && !emailInvalid && !emailWait && !emailFormatError">Введите электронную почту</div>
                    <div class="color-danger" v-if="emailFormatError">Введите корректный email адрес</div>
                <div class="color-danger" v-if="emailError && emailInvalid && !emailWait">Введите e-mail, которым вы пользуетесь</div>
                <div class="color-danger" v-if="domainError && isSettingsValidation">Введите Вашу корпоративную почту</div>
                <div class="color-danger" v-if="emailError && !emailInvalid && !emailWait && !emailAcceptable">Для e-mail разрешены следующие домены: {{ emailDomains }} </div>
                <div class="color-danger" v-if="emailError && emailWait">Вы уже запросили код.<br/>Проверьте почту или попробуйте снова через 1 минуту.</div>
                <div class="color-danger" v-if="teamError">Произошла ошибка: {{ teamStatus }}</div>
                    <div class="color-danger" v-if="extendedAuthError">{{ extendedAuthError }}</div>
              </div>
                </div>
              </div>

              <!-- Шаг ввода email -->
              <div v-if="isExtendedAuthEmailRequired" class="form__email-required">
                <div class="form__label" v-if="isVkEmailRequired">
                  <span class="rr-button__icon rr-button__icon_auto">
                    <img src="/img/sso/VK.svg" width="32" height="32" alt="VK" />
                  </span>
                </div>
                <div class="main__title">{{ vkFirstName ? (vkFirstName + ', укажите электронную почту') : 'Укажите электронную почту' }}</div>
                <div class="form__inputs">
                  <Input
                    size="md"
                    placeholder="your@email.com"
                    name="email"
                    type="email"
                    id="login-email-required"
                    v-model.trim="email"
                    mobile
                    :state="emailError ? 'error' : null"
                    @keydown="onEmailKeydown"
                  />
              <Button
                variant="primary"
                size="md"
                text="Получить код"
                mobile
                @click="onGetCode"
                :disabled="emailError"
              ></Button>
            </div>
                <div class="email-errors">
                  <div class="color-danger" v-if="emailError && !emailFormatError">Введите электронную почту</div>
                  <div class="color-danger" v-if="emailFormatError">Введите корректный email адрес</div>
                  <div class="color-danger" v-if="extendedAuthError">{{ extendedAuthError }}</div>
            </div>
                <!-- Кнопку Отменить скрываем на шаге email-required -->
        </div>
          </div>
          </div>

          <!-- Шаг ввода кода -->
          <div v-if="isExtendedAuthCodeRequired">
          <div class="main__title main__title_code">Введите код</div>
            <div class="main__subtitle">Мы отправили код на почту <b>{{email}}</b></div>
          <div class="main__form">
            <div class="form__label form__label_code">Код из письма</div>
            <div class="form__inputs form__inputs_code">
              <Input
                id="login-auth-code0"
                size="md"
                type="number"
                placeholder="•"
                :state="codeError ? 'error' : null"
                @keydown="onKeyDown(0, $event)"
                @input="onInput"
                v-model="code[0]"
                noStateIcons
                mobile
              />
              <Input
                id="login-auth-code1"
                size="md"
                type="number"
                placeholder="•"
                :state="codeError ? 'error' : null"
                @keydown="onKeyDown(1, $event)"
                v-model="code[1]"
                noStateIcons
                mobile
              />
              <Input
                id="login-auth-code2"
                size="md"
                type="number"
                placeholder="•"
                :state="codeError ? 'error' : null"
                @keydown="onKeyDown(2, $event)"
                v-model="code[2]"
                noStateIcons
                mobile
              />
              <Input
                id="login-auth-code3"
                size="md"
                type="number"
                placeholder="•"
                :state="codeError ? 'error' : null"
                @keydown="onKeyDown(3, $event)"
                v-model="code[3]"
                noStateIcons
                mobile
              />
            </div>
            <div class="code-errors">
              <div class="color-danger" v-if="codeSendError">Не удается отправить код. Попробуйте ещё раз.</div>
                <div class="color-danger" v-if="codeError && !tokenError && showInvalidCodeMessage">Неверный код. Попробуйте ещё раз.</div>
              <div class="color-danger" v-if="codeError && tokenError">
                  <span>Код устарел.</span> <Link variant="secondary" size="xs" @click="onResendCode">Запросить повторно.</Link>
              </div>
                <div class="color-danger" v-if="extendedAuthError">{{ extendedAuthError }}</div>
            </div>
              <div v-if="countdownText !== '00:00'" class="form__retry">Запросить повторно через {{countdownText}}</div>
              <div v-if="countdownText === '00:00'" class="form__retry">
                <Link variant="secondary" size="sm" @click="onResendCode">Запросить код повторно</Link>
            </div>
          </div>
          <div class="main__links">
              <Link variant="secondary" size="sm" icon-left="left" @click="onCancelAuth">
                Отменить
            </Link>
            <Link variant="primary" size="sm" icon-left="info-circle-s" @click="codeInfoModal = true">
              Не приходит письмо?
            </Link>
            </div>
          </div>
        </div>
      </div>
      <div v-if="$root.isDesktop" class="login__image">
        <div class="image" :style="`background-image: url('${cover}');`"></div>
      </div>
    </div>

    <Modal
      :active="codeInfoModal"
      name="CodeInfoModal"
      :title="codeInfoText.title"
      :subtitle="codeInfoText.subtitle"
      icon="info-circle"
      @close.prevent="codeInfoModal = false"
    >
      <Button
        variant="secondary"
        size="lg"
        mobile
        @click="codeInfoModal = false"
      >
        Понятно
      </Button>
    </Modal>

    <Modal
      :active="emailBlocked"
      :img="feelingBlueRafiki"
      title="Ваш аккаунт заблокирован"
      name="EmailBlockedModal"
      :class="{ 'for-mobile-app': isMobileApp }"
      @close.prevent="onEmailBlockedClose"
    >
      <div class="rr-modal__subtitle modal__item">
        Результаты аннулированы за нарушение <a :href="supportReglament" target="_blank">регламента проекта</a>.<br/><br/>
        Если вы считаете, что это произошло по ошибке,<br/>
        <a href="#" @click.prevent="onSupport">напишите в службу поддержки</a>.<br/>
        Порядок подачи апелляции прописан в <a :href="supportReglament" target="_blank">регламенте</a>.
      </div>
    </Modal>

    <Modal
      :active="teamOffLimits"
      name="TeamOffLimitsModal"
      title="Ваша команда уже собрана"
      :subtitle="teamOffLimitsSubtitle"
      icon="info-circle"
      @close.prevent="onTeamOffLimitsClose"
    >
      <Button
        variant="secondary"
        size="lg"
        mobile
        @click="onTeamOffLimitsClose"
      >
        Понятно
      </Button>
    </Modal>

    <Modal
      :active="noInvitation"
      name="noInvitationModal"
      title="У вас нет приглашения"
      :subtitle="noInvitationSubtitle"
      icon="info-circle"
      @close.prevent="onNoInvitationClose"
    >
      <Button
        variant="secondary"
        size="lg"
        mobile
        @click="onNoInvitationClose"
      >
        Понятно
      </Button>
    </Modal>

    <Modal
      :active="teamNoInvitation"
      name="TeamNoInvitationModal"
      title="Ваш почтовый адрес не привязан ни к одной команде"
      :subtitle="teamNoInvitationSubtitle"
      icon="info-circle"
      @close.prevent="onTeamNoInvitationClose"
    >
      <Button
        variant="secondary"
        size="lg"
        mobile
        @click="onTeamNoInvitationClose"
      >
        Понятно
      </Button>
    </Modal>

    <SupportDialog
      :active="supportModal"
      :isMobileApp="isMobileApp"
      @close="onSupportModalClose()"
      @form-submitted="handleFormSubmit"
    />

    <Modal
      name="successModal"
      :active="successModal"
      :closable="true"
      :class="{ 'for-mobile-app': isMobileApp }"
      @close="onSuccessModalClose"
      >
      <div class="modal__success">
        <Icon name="check-circle"></Icon>
        <p class="modal__success-title">Вопрос отправлен</p>
        <p class="modal__success-text">Обычно отвечаем в течение трёх рабочих дней. Ответ придёт на почту <span>{{ email }}</span> </p>
        <div class="moadal__success-action">
          <Button
              variant="secondary"
              size="lg"
              tag="a"
              mobile
              @click="onSuccessModalClose"
            >
              Закрыть
            </Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Cookies from 'js-cookie';
import Alert from '@rr-component-library/alert/src/main';
import Button from '@rr-component-library/button/src/main';
import Input from '@rr-component-library/input/src/main';
import SupportDialog from '@/components/SupportDialog/SupportDialog.vue';

import { getCountdown, stringPadLeft } from '@/assets/js/helpers';

export default {
  name: 'Login',
  components: {
    Alert,
    Button,
    Input,
    SupportDialog,
  },
  props: {
    logo: String,
    cover: String,
  },
  data() {
    return {
      step: 'start',
      email: null,
      code: ['', '', '', ''],
      token: '',
      startDate: '',
      countdown: [],
      emailError: false,
      domainError: false,
      emailInvalid: false,
      emailWait: false,
      emailAcceptable: true,
      emailFormatError: false,
      emailBlocked: false,
      codeError: false,
      tokenError: false,
      ssoError: false,
      vkError: false,
      yandexError: false,
      codeSendError: false,
      showInvalidCodeMessage: true,
      sending: false,
      sendingCode: false,
      codeInfoModal: false,
      supportModal: false,
      successModal: false,
      codeInfoText: {
        title: 'Не приходит письмо?',
        subtitle: 'Проверьте корректность ввода электронного адреса и папку "Спам".',
      },
      teamOffLimits: false,
      teamNoInvitation: false,
      noInvitation: false,
      teamError: false,
      vkAuthenticationFailed: false,

      marketingProgramAttributes: [],
      teamId: '',
      // Extended authentication states
      extendedAuthToken: null,
      extendedAuthStep: 'start', // start, email-required, code-required, success
      extendedAuthResult: null,
      extendedAuthError: null,
    };
  },
  computed: {
    ...mapGetters('settings', ['isPrivate', 'showSSO', 'options', 'resources']),
    ...mapGetters('user', [
      'accessToken',
      'isAuthenticated',
      'emptyProfile',
      'isMobileApp',
      'codeDetails',
      'providersAuth',
      'providersAuthStatus',
      'extendedAuthRequest',
      'extendedAuthRequestStatus',
      'extendedAuthProcessStatus',
      'extendedAuthChangeEmailStatus',
      'extendedAuthChangeEmailResult',
      'extendedAuthSubmitCodeStatus',
      'extendedAuthResendCodeStatus',
      'extendedAuthCancelStatus',
      'extendedAuthProcessResult',
      'extendedAuthSubmitCodeResult',
    ]),

    ...mapGetters('content', ['rule']),
    countdownText() {
      const c = this.countdown;
      return `${stringPadLeft(c[2], '0', 2)}:${stringPadLeft(c[3], '0', 2)}`;
    },

    isAuthSSO() {
      // Если уже установлен vkEmailRequired, не запускаем повторный SSO процесс
      if (this.$route.query && this.$route.query.vkEmailRequired === '1') {
        return false;
      }

      const hasCodeStateDevice = this.$route.query && this.$route.query.code && this.$route.query.state && this.$route.query.device_id;
      const isSSORoute = this.$route.name === 'AuthSSO' || this.$route.path === '/sso' || this.$route.path === '/vksso' || this.$route.path === '/yandexsso';
      const isVKSSO = this.$route.query.sso === 'vk';
      const isYandexSSO = this.$route.query.sso === 'yandex' || this.$route.query.type === 'YANDEX';

      return hasCodeStateDevice || isSSORoute || isVKSSO || isYandexSSO;
    },

    isVKSSO() {
      return this.$route.query && (
        this.$route.query.cv
        || this.$route.query.sso === 'vk'
        || (this.$route.query.code && String(this.$route.query.code).startsWith('vk2.'))
      );
    },

    isYandexSSO() {
      return this.$route.query && (
        this.$route.query.cv
        || this.$route.query.sso === 'yandex'
        || this.$route.query.type === 'YANDEX'
      );
    },

    queryAuthToken() {
      return this.$route.query.authToken;
    },
    queryVKToken() {
      return this.$route.query.code;
    },
    loginReturnUrl() {
      return this.$route.query.loginReturnUrl;
    },
    showLoginBlocked() {
      return this.$route.query.showLoginBlocked;
    },
    emailFilters() {
      return this.options ? this.options.emailFilters || [] : [];
    },
    emailDomains() {
      return this.emailFilters.length > 0 ? this.emailFilters.join(', ') : '';
    },
    feelingBlueRafiki() {
      return this.resources ? this.resources.feelingBlueRafiki || '' : '';
    },
    supportReglament() {
      return this.rule ? this.rule.url || '#' : '#';
    },
    supportEmail() {
      return this.resources ? this.resources.supportEmail || '#' : '#';
    },
    supportEmailText() {
      return this.resources ? this.resources.supportEmailText || '' : '';
    },
    emailBlockedSubtitle() {
      return `Результаты аннулированы за нарушение <a href="${this.supportReglament}" target="_blank">регламента проекта</a>.<br/><br/>
      Если вы считаете, что это произошло по ошибке,<br/>
      <a @click="clickModalSupport">напишите в службу поддержки</a>.<br/>
      Порядок подачи апелляции прописан в <a href="${this.supportReglament}" target="_blank">регламенте</a>.`;
    },
    teamNoInvitationSubtitle() {
      return this.resources ? this.resources.teamNoInvitationSubtitle || '' : '';
    },
    noInvitationSubtitle() {
      return `Обратитесь в техническую поддержку Программы
      <a href="mailto:${this.supportEmail}">${this.supportEmailText || this.supportEmail}</a>`;
    },
    teamOffLimitsSubtitle() {
      return `Ваша команда уже собрана. Обратитесь в техническую поддержку Программы
      <a href="mailto:${this.supportEmail}">${this.supportEmailText || this.supportEmail}</a>`;
    },
    isClubEnabled() {
      return this.options ? this.options.isClubEnabled === true : false;
    },
    isSettingsValidation() {
      return this.options ? this.options.settingsValidation === true : false;
    },
    // Определяем доступные провайдеры авторизации
    availableProviders() {
      if (!this.providersAuth || !Array.isArray(this.providersAuth)) {
        return [];
      }
      return this.providersAuth;
    },
    isVkEmailRequired() {
      return this.$route.query && this.$route.query.vkEmailRequired === '1';
    },
    vkFirstName() {
      if (!(this.$route.query && this.$route.query.vkEmailRequired === '1')) return '';
      try {
        return localStorage.getItem('vk_user_first_name') || '';
      } catch (e) { return ''; }
    },
    hasEmailProvider() {
      return this.availableProviders.some((provider) => provider.type === 'Email');
    },
    hasSSOProvider() {
      return this.availableProviders.some((provider) => provider.type === 'RussiaRunningSso');
    },
    ssoProvider() {
      return this.availableProviders.find((provider) => provider.type === 'RussiaRunningSso');
    },
    hasVKProvider() {
      return this.availableProviders.some((provider) => provider.type === 'WebVkSso');
    },
    vkProvider() {
      return this.availableProviders.find((provider) => provider.type === 'WebVkSso');
    },
    hasYandexProvider() {
      return this.availableProviders.some((provider) => provider.type === 'YandexSso');
    },
    yandexProvider() {
      return this.availableProviders.find((provider) => provider.type === 'YandexSso');
    },
    // Extended authentication computed properties
    isExtendedAuthStart() {
      return this.extendedAuthStep === 'start';
    },
    isExtendedAuthEmailRequired() {
      return this.extendedAuthStep === 'email-required';
    },
    isExtendedAuthCodeRequired() {
      return this.extendedAuthStep === 'code-required';
    },
    isExtendedAuthSuccess() {
      return this.extendedAuthStep === 'success';
    },
    teamStatus() {
      return this.extendedAuthError || 'Неизвестная ошибка';
    },
  },
  watch: {
    email(val) {
      if (val) {
        this.emailError = false;
        this.emailFormatError = false;
      }
      this.domainError = false;
      this.emailInvalid = false;
      this.emailAcceptable = true;
      this.teamError = false;
    },
  },
  methods: {
    ...mapMutations('user', [
      'setAccessToken',
      'setAuthenticated',
    ]),
    ...mapActions('user', [
      'getProfile',
      'getCodeDetails',
      'getProvidersAuth',
      'createAuthRequest',
      'processAuthRequest',
      'changeEmail',
      'submitCode',
      'resendCode',
      'cancelAuthRequest',
    ]),

    ...mapActions('content', ['getRule']),
    ...mapActions('exercises', ['sendSupport']),
    onHashChange() {
      const hash = window.location.hash.split('=');
      if (hash[0] === '#!showSupport') this.showSupport(hash);
      else if (hash[0] === '#!showSuccess') this.showSuccess(hash);
      else {
        this.clearHash();
        this.supportModal = false;
        this.successModal = false;
      }
    },
    onSupport() {
      this.emailBlocked = false;
      this.$router.replace({ path: '/auth' });
      setTimeout(() => { window.location.hash = '#!showSupport=true'; }, 100);
    },
    onSupportModalClose() {
      window.location.hash = '#!showSupport=false';
    },
    onSuccess() {
      window.location.hash = '#!showSuccess=true';
    },
    onSuccessModalClose() {
      window.location.hash = '#!showSuccess=false';
      this.email = '';
    },
    handleFormSubmit(formData) {
      this.sendSupport(formData)
        .then(() => {
          this.email = formData.email;
          this.supportModal = false;
          setTimeout(() => { window.location.hash = '#!showSuccess=true'; }, 100);
        });
    },
    onEmailKeydown(event) {
      if (event.key === 'Enter') {
        // Сбрасываем ошибки перед валидацией
        this.emailError = false;
        this.emailFormatError = false;
        this.onGetCode();
      }
    },
    clearOtherProviderStates(currentProvider) {
      // Сбрасываем блокирующие ошибки и локальные состояния
      this.ssoError = false;
      this.vkError = false;
      this.yandexError = false;
      this.extendedAuthError = null;

      // Очищаем общие состояния SSO
      sessionStorage.removeItem('extendedAuthToken');
      sessionStorage.removeItem('authFromSSO');
      sessionStorage.removeItem('ssoAccessAttributes');
      sessionStorage.removeItem('vkAuth');
      sessionStorage.removeItem('yandexAuth');

      // Удаляем PKCE параметры и данные VK, если запускается не VK поток
      if (currentProvider !== 'vk') {
        localStorage.removeItem('vk_code_verifier');
        localStorage.removeItem('vk_state');
        localStorage.removeItem('vk_base_redirect_url');
        localStorage.removeItem('vk_user_first_name');
      }

      // Удаляем PKCE параметры и данные Yandex, если запускается не Yandex поток
      if (currentProvider !== 'yandex') {
        localStorage.removeItem('yandex_code_verifier');
        localStorage.removeItem('yandex_state');
        localStorage.removeItem('yandex_base_redirect_url');
        localStorage.removeItem('yandex_user_first_name');
      }
    },
    clearEmailRequiredQueryFlags() {
      const { query, name } = this.$route;
      if (query && (query.vkEmailRequired || query.yandexEmailRequired)) {
        const updated = { ...query };
        delete updated.vkEmailRequired;
        delete updated.yandexEmailRequired;
        this.$router.replace({ name: name || 'Auth', query: updated }).catch(() => {});
      }
    },
    onSSO() {
      const oldToken = sessionStorage.getItem('extendedAuthToken');
      this.clearOtherProviderStates('sso');
      if (oldToken) {
        this.cancelAuthRequest({ token: oldToken }).catch(() => {});
      }
      this.clearEmailRequiredQueryFlags();
      this.extendedAuthStep = 'start';
      this.email = '';
      this.sending = true;
      this.ssoError = false;
      if (!this.ssoProvider) {
        this.ssoError = true;
        this.sending = false;
        return;
      }

      // Extended Auth SSO (RR): create → redirect to RR → return → process Success
      this.setProgramAttributes()
        .then(() => this.createAuthRequest({ providerType: this.ssoProvider.type }))
        .then(() => {
          if (this.extendedAuthRequestStatus !== 200) {
            this.ssoError = true;
            this.sending = false;
            return Promise.reject(new Error('Request failed'));
          }

          const token = this.extendedAuthRequest?.token;
          let baseUrl = this.getAuthDataValue(this.extendedAuthRequest?.authData, 'BaseRedirectUrl', null);
          if (!baseUrl || (typeof baseUrl === 'string' && baseUrl.trim() === '')) {
            baseUrl = 'https://test.rr-dev.ru';
          }
          if (!token || !baseUrl) {
            this.ssoError = true;
            this.sending = false;
            return Promise.reject(new Error('Invalid token or baseUrl'));
          }

          this.extendedAuthToken = token;
          sessionStorage.setItem('extendedAuthToken', token);

          // Формируем returnUrl и уходим на RR, обработка будет на /sso
          const currentUrl = new URL(`${window.location.origin}/sso?type=RR`);
          currentUrl.searchParams.append('from', 'mp');
          const encodedUrl = encodeURIComponent(currentUrl.href);
          const loginUrl = `${baseUrl}/login?returnUrl=${encodedUrl}`;
          window.location.href = loginUrl;
          return true;
        })
        .catch(() => {
          this.ssoError = true;
          this.sending = false;
        });
    },
    async onYandex() {
      const oldToken = sessionStorage.getItem('extendedAuthToken');
      this.clearOtherProviderStates('yandex');
      if (oldToken) {
        this.cancelAuthRequest({ token: oldToken }).catch(() => {});
      }
      this.clearEmailRequiredQueryFlags();
      this.extendedAuthStep = 'start';
      this.email = '';
      this.sending = true;
      this.yandexError = false;

      if (!this.yandexProvider) {
        this.yandexError = true;
        this.sending = false;
        return;
      }

      // Генерируем PKCE параметры
      const codeVerifier = this.generateCodeVerifier();
      const codeChallenge = await this.generateCodeChallenge(codeVerifier);
      const state = this.generateState();

      // Сохраняем PKCE параметры в localStorage
      localStorage.setItem('yandex_code_verifier', codeVerifier);
      localStorage.setItem('yandex_state', state);

      // device_id для Yandex необязательный, не генерируем

      // Создаем запрос расширенной авторизации и сразу уходим на Яндекс
      this.setProgramAttributes()
        .then(() => this.createAuthRequest({ providerType: this.yandexProvider.type }))
        .then(() => {
          if (this.extendedAuthRequestStatus !== 200) {
            this.yandexError = true;
            this.sending = false;
            return Promise.reject(new Error('Request failed'));
          }

          const token = this.extendedAuthRequest?.token;
          const clientId = this.getAuthDataValue(this.extendedAuthRequest?.authData, 'ClientId', this.yandexProvider.providerId);
          const baseAuthUrl = this.getAuthDataValue(this.extendedAuthRequest?.authData, 'BaseAuthUrl', 'https://oauth.yandex.ru/authorize');

          // redirect_uri: домен с обработчиком yandexsso.html + параметры mp и cv
          const mpReturnTo = `${window.location.origin}/sso?returnTo=register&type=YANDEX`;
          const baseRedirectUrl = this.getAuthDataValue(this.extendedAuthRequest?.authData, 'BaseRedirectUrl', 'https://yandexsso.scount-dev.ru');
          const redirectUri = `${baseRedirectUrl}?mp=${encodeURIComponent(mpReturnTo)}&cv=${encodeURIComponent(codeVerifier)}`;
          localStorage.setItem('yandex_base_redirect_url', baseRedirectUrl);
          const scopes = this.getAuthDataValue(this.extendedAuthRequest?.authData, 'Scopes', 'login:email,login:info');

          if (!token || !clientId) {
            this.yandexError = true;
            this.sending = false;
            return Promise.reject(new Error('Invalid Yandex auth data'));
          }

          this.extendedAuthToken = token;
          sessionStorage.setItem('extendedAuthToken', token);

          // Формируем state для Яндекс (только nonce)
          const stateData = {
            nonce: state,
          };
          const encodedState = btoa(JSON.stringify(stateData));

          // Формируем URL для Яндекс OAuth с PKCE параметрами и редиректим
          const yandexUrl = new URL(baseAuthUrl);
          yandexUrl.searchParams.append('response_type', 'code');
          yandexUrl.searchParams.append('client_id', clientId);
          yandexUrl.searchParams.append('redirect_uri', redirectUri);
          yandexUrl.searchParams.append('code_challenge', codeChallenge);
          yandexUrl.searchParams.append('code_challenge_method', 'S256');
          yandexUrl.searchParams.append('state', encodedState);
          yandexUrl.searchParams.append('scope', scopes);
          yandexUrl.searchParams.append('force_confirm', 'yes');
          // device_id необязательный для Yandex, не передаем

          window.location.href = yandexUrl.href;
          return true;
          // navigation happens; no further actions here
        })
        .catch(() => {
          this.yandexError = true;
          this.sending = false;
        });
    },

    async onVK() {
      const oldToken = sessionStorage.getItem('extendedAuthToken');
      this.clearOtherProviderStates('vk');
      if (oldToken) {
        this.cancelAuthRequest({ token: oldToken }).catch(() => {});
      }
      this.clearEmailRequiredQueryFlags();
      this.extendedAuthStep = 'start';
      this.email = '';
      this.sending = true;
      this.vkError = false;

      if (!this.vkProvider) {
        this.vkError = true;
        this.sending = false;
        return;
      }

      // Генерируем PKCE параметры
      const codeVerifier = this.generateCodeVerifier();
      const codeChallenge = await this.generateCodeChallenge(codeVerifier);
      const state = this.generateState();

      // Сохраняем PKCE параметры в localStorage
      localStorage.setItem('vk_code_verifier', codeVerifier);
      localStorage.setItem('vk_state', state);

      // Создаем запрос расширенной авторизации и сразу уходим на VK
      this.setProgramAttributes()
        .then(() => this.createAuthRequest({ providerType: this.vkProvider.type }))
        .then(() => {
          if (this.extendedAuthRequestStatus !== 200) {
            this.vkError = true;
            this.sending = false;
            return Promise.reject(new Error('Request failed'));
          }

          const token = this.extendedAuthRequest?.token;
          const clientId = this.getAuthDataValue(this.extendedAuthRequest?.authData, 'ClientId', this.vkProvider.providerId);
          const baseAuthUrl = this.getAuthDataValue(this.extendedAuthRequest?.authData, 'BaseAuthUrl', 'https://id.vk.com/authorize');

          // redirect_uri: домен с обработчиком vksso.html + параметры mp и cv
          const mpReturnTo = `${window.location.origin}/sso?returnTo=register&type=VK`;
          const baseRedirectUrl = this.getAuthDataValue(this.extendedAuthRequest?.authData, 'BaseRedirectUrl', 'https://vksso.scount.pro');
          const redirectUri = `${baseRedirectUrl}?mp=${encodeURIComponent(mpReturnTo)}&cv=${encodeURIComponent(codeVerifier)}`;
          localStorage.setItem('vk_base_redirect_url', baseRedirectUrl);
          const scopes = this.getAuthDataValue(this.extendedAuthRequest?.authData, 'Scopes', 'vkid.personal_info,email');

          if (!token || !clientId) {
            this.vkError = true;
            this.sending = false;
            return Promise.reject(new Error('Invalid VK auth data'));
          }

          this.extendedAuthToken = token;
          sessionStorage.setItem('extendedAuthToken', token);

          // Формируем state для VK (только nonce)
          const stateData = {
            nonce: state,
          };
          const encodedState = btoa(JSON.stringify(stateData));

          // Формируем URL для VK ID с PKCE параметрами и редиректим
          const vkUrl = new URL(baseAuthUrl);
          vkUrl.searchParams.append('response_type', 'code');
          vkUrl.searchParams.append('client_id', clientId);
          vkUrl.searchParams.append('redirect_uri', redirectUri);
          vkUrl.searchParams.append('code_challenge', codeChallenge);
          vkUrl.searchParams.append('code_challenge_method', 'S256');
          vkUrl.searchParams.append('state', encodedState);
          vkUrl.searchParams.append('scope', scopes);

          window.location.href = vkUrl.href;
          return true;
          // navigation happens; no further actions here
        })
        .catch(() => {
          this.vkError = true;
          this.sending = false;
        });
    },
    // Валидация VK state для безопасности
    validateVKState() {
      try {
        const rawState = this.$route.query && this.$route.query.state;
        const storedNonce = localStorage.getItem('vk_state');

        if (rawState && storedNonce) {
          const parsed = JSON.parse(atob(rawState));
          if (parsed && parsed.nonce && parsed.nonce !== storedNonce) {
            return false;
          }
        }
        return true;
      } catch (e) {
        return true; // Игнорируем ошибки парсинга
      }
    },

    // Валидация Yandex state для безопасности
    validateYandexState() {
      try {
        const rawState = this.$route.query && this.$route.query.state;
        const storedNonce = localStorage.getItem('yandex_state');

        if (rawState && storedNonce) {
          const parsed = JSON.parse(atob(rawState));
          if (parsed && parsed.nonce && parsed.nonce !== storedNonce) {
            return false;
          }
        }
        return true;
      } catch (e) {
        return true; // Игнорируем ошибки парсинга
      }
    },

    // Получение VK параметров
    getVKParameters() {
      // Получаем PKCE параметры: code_verifier из query параметра cv или из localStorage (если cv нет)
      let codeVerifier = null;
      if (this.$route.query && this.$route.query.cv) {
        codeVerifier = this.$route.query.cv;
      } else {
        codeVerifier = localStorage.getItem('vk_code_verifier') || null;
      }

      return {
        codeVerifier,
        deviceId: this.$route.query.device_id,
        vkToken: this.queryVKToken,
      };
    },

    // Получение Yandex параметров
    getYandexParameters() {
      // Получаем PKCE параметры: code_verifier из query параметра cv или из localStorage (если cv нет)
      let codeVerifier = null;
      if (this.$route.query && this.$route.query.cv) {
        codeVerifier = this.$route.query.cv;
      } else {
        codeVerifier = localStorage.getItem('yandex_code_verifier') || null;
      }

      // Получаем device_id только из query параметров (если Yandex вернул)
      const deviceId = this.$route.query.state_cluster_id || this.$route.query.device_id;

      return {
        codeVerifier,
        deviceId,
        yandexToken: this.$route.query.code,
      };
    },

    // Формирование redirect_uri для VK
    buildVKRedirectUri(codeVerifier) {
      const mpReturnTo = `${window.location.origin}/sso`;
      const baseRedirectUrl = localStorage.getItem('vk_base_redirect_url') || 'https://vksso.scount.pro';
      return `${baseRedirectUrl}?mp=${encodeURIComponent(mpReturnTo)}&cv=${encodeURIComponent(codeVerifier || '')}`;
    },

    // Формирование redirect_uri для Yandex
    buildYandexRedirectUri(codeVerifier) {
      const mpReturnTo = `${window.location.origin}/sso`;
      const baseRedirectUrl = localStorage.getItem('yandex_base_redirect_url') || 'https://yandexsso.scount-dev.ru';
      return `${baseRedirectUrl}?mp=${encodeURIComponent(mpReturnTo)}&cv=${encodeURIComponent(codeVerifier || '')}`;
    },

    // Обработка VK потока авторизации
    async processVKFlow(token) {
      const { codeVerifier, deviceId, vkToken } = this.getVKParameters();

      // Убеждаемся, что маркетинговые атрибуты загружены
      await this.setProgramAttributes();

      // Получаем маркетинговые атрибуты
      const marketingAttributes = this.getMarketingAttributes();

      // Формируем атрибуты для VK авторизации (VK + маркетинговые)
      const vkAttributes = [
        vkToken ? { key: 'vk.code', value: vkToken } : null,
        codeVerifier ? { key: 'vk.code_verifier', value: codeVerifier } : null,
        deviceId ? { key: 'vk.device_id', value: deviceId } : null,
      ].filter(Boolean);

      // Объединяем VK атрибуты с маркетинговыми
      const attributes = [...marketingAttributes, ...vkAttributes];

      try {
        await this.processAuthRequest({ token, attributes });
      } catch (error) {
        // processAuthRequest выбрасывает исключение при ошибке
      }

      // Обрабатываем ошибки VK потока
      if (this.extendedAuthProcessStatus !== 200) {
        this.handleProcessError();
        throw new Error('VK process error');
      }

      return this.extendedAuthProcessResult;
    },

    // Обработка Yandex потока авторизации
    async processYandexFlow(token) {
      const { codeVerifier, deviceId, yandexToken } = this.getYandexParameters();

      // Устанавливаем атрибуты для Yandex SSO (без вызова getCodeDetails)
      await this.setYandexProgramAttributes();

      // Получаем маркетинговые атрибуты
      const marketingAttributes = this.getMarketingAttributes();

      // Формируем атрибуты для Yandex авторизации (Yandex + маркетинговые)
      const yandexAttributes = [
        yandexToken ? { key: 'ya.code', value: yandexToken } : null,
        codeVerifier ? { key: 'ya.code_verifier', value: codeVerifier } : { key: 'ya.code_verifier', value: '' },
        // deviceId для Yandex не обязателен, добавляем только если есть
        deviceId ? { key: 'ya.device_id', value: deviceId } : null,
      ].filter(Boolean);

      // Объединяем Yandex атрибуты с маркетинговыми (исключаем дубликаты Code)
      const filteredMarketingAttributes = marketingAttributes.filter((attr) => attr.key !== 'Code');
      const attributes = [...filteredMarketingAttributes, ...yandexAttributes];

      try {
        await this.processAuthRequest({ token, attributes });
      } catch (error) {
        // processAuthRequest выбрасывает исключение при ошибке, но мы обрабатываем это
        // через extendedAuthProcessStatus и extendedAuthProcessResult
      }

      // Обрабатываем ошибки Yandex потока
      if (this.extendedAuthProcessStatus !== 200) {
        this.handleProcessError();
        throw new Error('Yandex process error');
      }

      return this.extendedAuthProcessResult;
    },

    // Формирование маркетинговых атрибутов для RR SSO
    getMarketingAttributes() {
      return Array.isArray(this.marketingProgramAttributes) ? [...this.marketingProgramAttributes] : [];
    },

    // Добавление RussiaRunningToken к атрибутам
    addRussiaRunningToken(attributes) {
      if (this.queryAuthToken) {
        attributes.push({ key: 'RussiaRunningToken', value: this.queryAuthToken });
      }
      return attributes;
    },

    // Формирование атрибутов для RR SSO
    buildRRAttributes() {
      const attributes = this.getMarketingAttributes();
      return this.addRussiaRunningToken(attributes);
    },

    // Обработка RR потока авторизации
    async processRRFlow(token) {
      const attributes = this.buildRRAttributes();
      return this.processAuthRequest({ token, attributes });
    },

    // Обработка результата processAuthRequest
    async handleProcessResult() {
      if (this.extendedAuthProcessStatus !== 200) {
        this.handleProcessError();
        return false;
      }

      const resultObj = this.extendedAuthProcessResult || {};

      if (resultObj.result === 'Success' && resultObj.accessToken) {
        // Проверяем, это ли VK поток
        const isVKFlow = this.$route.query && (
          this.$route.query.cv
          || this.$route.query.sso === 'vk'
          || (this.queryVKToken && String(this.queryVKToken).startsWith('vk2.'))
        );

        if (isVKFlow && resultObj.attributes) {
          // Сохраняем атрибуты VK для предзаполнения анкеты
          sessionStorage.setItem('authFromSSO', 'true');
          sessionStorage.setItem('vkAuth', 'true');
          sessionStorage.setItem('ssoAccessAttributes', JSON.stringify(resultObj.attributes));
        }

        // Успешная авторизация
        Cookies.set('token', resultObj.accessToken, { expires: 365 });
        this.setAccessToken(resultObj.accessToken);
        this.setAuthenticated(true);
        sessionStorage.removeItem('extendedAuthToken');
        this.checkProfile();
        return true;
      }

      if (resultObj.result === 'EmailRequired') {
        return this.handleEmailRequired(resultObj);
      }

      // Иное — ошибка UI
      this.extendedAuthError = 'Неожиданный результат авторизации';
      this.sending = false;
      return false;
    },

    // Обработка случая когда требуется email
    handleEmailRequired(resultObj) {
      // Ветка VK: если есть VK маркеры, ведём на ввод e‑mail в Login с vkEmailRequired=1
      const isVKReturn = (this.$route.query && (this.$route.query.cv || this.$route.query.sso === 'vk' || (this.queryVKToken && String(this.queryVKToken).startsWith('vk2.'))));

      if (resultObj.token) {
        this.extendedAuthToken = resultObj.token;
        sessionStorage.setItem('extendedAuthToken', resultObj.token);
      }
      sessionStorage.setItem('authFromSSO', 'true');
      const userAttributes = resultObj.attributes || [];
      sessionStorage.setItem('ssoAccessAttributes', JSON.stringify(userAttributes));

      if (isVKReturn) {
        // Пробросим имя для заголовка формы
        if (resultObj.userFirstName) localStorage.setItem('vk_user_first_name', resultObj.userFirstName);
        // Помечаем VK поток и включаем шаг ввода email без ожидания монтирования
        sessionStorage.setItem('vkAuth', 'true');
        this.extendedAuthStep = 'email-required';
        this.ssoError = false;
        this.vkError = false;
        this.sending = false;
        this.email = '';
        this.$nextTick(() => { this.setFocusToEmail(); });
        // Сохраняем флаг в URL (для UI-меток), но состояние уже переведено
        const q = { ...(this.$route.query || {}), vkEmailRequired: '1' };
        this.$router.replace({ name: 'Auth', query: q }).catch(() => {});
      } else {
        // RR: на регистрацию
        this.$router.push({ name: 'Register' }).catch(() => {});
      }
      return true;
    },

    async authSSOExtendedReturn() {
      // Завершение SSO после возвращения с провайдера
      const token = sessionStorage.getItem('extendedAuthToken');

      // Безопасность: проверяем соответствие nonce/state для VK и Yandex
      if (!this.validateVKState() || !this.validateYandexState()) {
        return false;
      }

      if (!token) {
        return false;
      }

      this.extendedAuthToken = token;

      try {
        // Определяем тип потока и обрабатываем соответствующим образом
        const isVKFlow = this.$route.query && (
          this.$route.query.sso === 'vk'
          || (this.queryVKToken && String(this.queryVKToken).startsWith('vk2.'))
          || (this.$route.query.cv && this.$route.path === '/vksso')
        );
        const isYandexFlow = this.$route.query && (
          this.$route.query.sso === 'yandex'
          || this.$route.query.type === 'YANDEX'
          || (this.$route.query.cv && this.$route.path === '/yandexsso')
        );

        if (isVKFlow) {
          await this.processVKFlow(token);

          // Обрабатываем результат VK потока
          if (this.extendedAuthProcessStatus === 200) {
            return await this.handleProcessResult();
          }
          return false;
        }

        if (isYandexFlow) {
          await this.processYandexFlow(token);

          // Обрабатываем результат Yandex потока
          if (this.extendedAuthProcessStatus === 200) {
            return await this.handleProcessResult();
          }
          return false;
        }

        // Для RR потока устанавливаем атрибуты программы
        await this.setProgramAttributes();
        await this.processRRFlow(token);

        // Обрабатываем результат только для RR потока
        if (!isVKFlow && !isYandexFlow) {
          return await this.handleProcessResult();
        }
        // Для VK и Yandex потоков результат уже обработан в processVKFlow/processYandexFlow
        return this.extendedAuthProcessResult?.result === 'Success';
      } catch (error) {
        // Ошибки VK и Yandex потоков уже обработаны в processVKFlow/processYandexFlow через handleProcessError
        // Здесь только сбрасываем состояние
        this.sending = false;
        return false;
      }
    },
    // Валидация email
    validateEmail() {
      this.emailInvalid = false;
      this.emailWait = false;
      this.emailFormatError = false;
      this.emailError = false;

      // Проверка на пустое значение
      if (!this.email || this.email.trim() === '') {
        this.emailError = true;
        return false;
      }

      // Проверка формата email
      if (!this.isEmailValid(this.email)) {
        this.emailFormatError = true;
        this.emailError = true;
        return false;
      }

      // Проверка домена
      this.emailAcceptable = this.isDomainAcceptable(this.email);
      if (!this.emailAcceptable) {
        this.emailError = true;
        return false;
      }

      return true;
    },

    // Обработка VK EmailRequired потока
    async handleVKEmailRequired() {
      const token = this.extendedAuthToken || sessionStorage.getItem('extendedAuthToken');
      if (!token) {
        this.extendedAuthError = 'Не найден токен авторизации';
        return;
      }

      this.sending = true;
      this.extendedAuthError = null;

      try {
        await this.changeEmail({ token, emailAddress: this.email });

        if (this.extendedAuthChangeEmailStatus === 200 || this.extendedAuthChangeEmailStatus === 204) {
          this.extendedAuthToken = token;
          this.extendedAuthStep = 'code-required';
          this.sending = false;
          this.startDate = new Date(Date.now() + 60000).toISOString();
          this.updateCountdown();
          setTimeout(() => { this.setInputs(); }, 100);
        } else {
          this.handleChangeEmailError();
        }
      } catch (error) {
        this.handleChangeEmailError();
      }
    },

    // Создание заявки на авторизацию
    async createEmailAuthRequest() {
      const emailProvider = this.availableProviders.find((provider) => provider.type === 'Email');
      if (!emailProvider) {
        this.extendedAuthError = 'Email провайдер недоступен';
        this.sending = false;
        throw new Error('Email provider not available');
      }

      await this.createAuthRequest({ providerType: emailProvider.type });

      if (this.extendedAuthRequestStatus !== 200) {
        this.handleCreateRequestError();
        throw new Error('Create request failed');
      }

      this.extendedAuthToken = this.extendedAuthRequest?.token;
    },

    // Обработка заявки авторизации
    async processEmailAuthRequest() {
      const attributes = this.getMarketingAttributes();
      await this.processAuthRequest({ token: this.extendedAuthToken, attributes });

      if (this.extendedAuthProcessStatus !== 200) {
        if (this.extendedAuthProcessStatus === 422) {
          this.handleProcessError();
        } else {
          this.handleProcessError();
        }
        throw new Error('Process error');
      }

      const result = this.extendedAuthProcessResult?.result;
      if (result !== 'EmailRequired') {
        this.extendedAuthError = `Неожиданный результат: ${result}`;
        this.sending = false;
        throw new Error('Unexpected result');
      }
    },

    // Отправка email и переход к вводу кода
    async sendEmailAndTransitionToCode() {
      await this.changeEmail({
        token: this.extendedAuthToken,
        emailAddress: this.email,
      });

      if (this.extendedAuthChangeEmailStatus === 200 || this.extendedAuthChangeEmailStatus === 204) {
        this.extendedAuthStep = 'code-required';
        this.sending = false;
        this.startDate = new Date(Date.now() + 60000).toISOString();
        this.updateCountdown();
        setTimeout(() => { this.setInputs(); }, 100);
      } else {
        this.handleChangeEmailError();
      }
    },

    // Обработка обычного email потока
    async handleRegularEmailFlow() {
      this.sending = true;
      this.extendedAuthError = null;

      try {
        await this.setProgramAttributes();
        await this.createEmailAuthRequest();
        await this.processEmailAuthRequest();
        await this.sendEmailAndTransitionToCode();
      } catch (error) {
        // Определяем, на каком шаге ошибка: changeEmail или process
        if (this.extendedAuthChangeEmailStatus && this.extendedAuthChangeEmailStatus !== 200 && this.extendedAuthChangeEmailStatus !== 204) {
          this.handleChangeEmailError();
        } else {
          this.handleProcessError();
        }
        this.sending = false;
      }
    },

    onGetCode() {
      if (this.sending) {
        return;
      }

      // Валидация email
      if (!this.validateEmail()) {
        return;
      }

      // Особый режим: VK EmailRequired — продолжаем ту же заявку (без создания Email провайдера)
      if (this.isVkEmailRequired) {
        this.handleVKEmailRequired();
        return;
      }

      // Обычный email поток
      this.handleRegularEmailFlow();
    },

    onResendCode() {
      if (!this.extendedAuthToken) {
        return;
      }

      this.sending = true;
      this.extendedAuthError = null;

      this.resendCode({ token: this.extendedAuthToken })
        .then(() => {
          if (this.extendedAuthResendCodeStatus === 200 || this.extendedAuthResendCodeStatus === 204) {
            this.startDate = new Date(Date.now() + 60000).toISOString();
            this.updateCountdown();
            this.sending = false;
          } else {
            this.handleAuthError(this.extendedAuthResendCodeStatus, null);
          }
        })
        .catch(() => {
          this.extendedAuthError = 'Произошла ошибка при повторной отправке кода';
          this.sending = false;
        });
    },
    onKeyDown(digitIndex, event) {
      if (digitIndex < 0 || digitIndex > 3) return;
      const r = new RegExp(/^[0-9]$/);
      const exclude = new RegExp(/^[-+.,e]$/, 'i');
      if (r.test(event.key)) {
        if (this.code[digitIndex].length === 1) {
          event.preventDefault();
          return;
        }
        if (digitIndex + 1 <= 3) {
          const nextItem = document.getElementById(`login-auth-code${digitIndex + 1}`);
          if (nextItem) {
            setTimeout(() => {
              nextItem.click();
              if (this.code[digitIndex + 1].length === 1) {
                setTimeout(() => { this.onCodeSubmit(); }, 100);
              }
            }, 100);
          }
        } else {
          setTimeout(() => { this.onCodeSubmit(); }, 100);
        }
      } else if (exclude.test(event.key)) {
        event.preventDefault();
        return;
      } else if (event.key === 'Backspace') {
        if (this.code[digitIndex].length === 0 && digitIndex > 0) {
          this.code[digitIndex - 1] = '';
          const prevItem = document.getElementById(`login-auth-code${digitIndex - 1}`);
          if (prevItem) setTimeout(() => { prevItem.click(); }, 100);
        }
      }
      this.codeError = false;
      this.tokenError = false;
      this.codeSendError = false;
    },
    onInput(value) {
      if (typeof value !== 'string') return;
      const code = value.trim();
      for (let i = 0; i < 4; i += 1) {
        this.code[i] = code[i] !== undefined ? code[i] : '';
      }
      if (code.length >= 4) {
        setTimeout(() => { this.onCodeSubmit(); }, 500);
      } else {
        const nextItem = document.getElementById(`login-auth-code${code.length}`);
        if (nextItem) setTimeout(() => { nextItem.click(); }, 100);
      }
    },

    onEmailBlockedClose() {
      this.resetToInitialState();
      window.location.reload();
    },

    setProgramAttributes() {
      // Очищаем старые атрибуты с Code из localStorage
      const storedAttributes = localStorage.getItem('authAttributes');
      if (storedAttributes) {
        try {
          const parsedAttributes = JSON.parse(storedAttributes);
          if (Array.isArray(parsedAttributes)) {
            const hasCode = parsedAttributes.some((attr) => attr.key === 'Code');
            const hasInvitationCode = parsedAttributes.some((attr) => attr.key === 'InvitationCode');
            // Если есть и Code и InvitationCode, удаляем Code
            if (hasCode && hasInvitationCode) {
              const filteredAttributes = parsedAttributes.filter((attr) => attr.key !== 'Code');
              if (filteredAttributes.length > 0) {
                localStorage.setItem('authAttributes', JSON.stringify(filteredAttributes));
              } else {
                localStorage.removeItem('authAttributes');
              }
            }
          }
        } catch (error) {
          // Игнорируем ошибки очистки
        }
      }

      // Проверяем marketingProgramCode в sessionStorage и localStorage
      const sessionMarketingCode = sessionStorage.getItem('marketingProgramCode');
      const localMarketingCode = localStorage.getItem('marketingProgramCode');

      let marketingProgramCode = sessionMarketingCode || localMarketingCode;
      const invitationTeamId = sessionStorage.getItem('invitationTeamId');
      const invitationCode = sessionStorage.getItem('invitationCode');

      // Инициализируем массив атрибутов
      this.marketingProgramAttributes = [];

      // Проверяем, что marketingProgramCode не является VK токеном
      if (marketingProgramCode && marketingProgramCode.startsWith('vk2.a.')) {
        // Очищаем VK токен из storage
        sessionStorage.removeItem('marketingProgramCode');
        localStorage.removeItem('marketingProgramCode');
        // Обновляем переменную, чтобы избежать дальнейшего использования VK токена
        marketingProgramCode = null;
        // НЕ выходим из метода, продолжаем обработку storedAttributes
      }

      // Получаем атрибуты из localStorage, если они есть
      if (storedAttributes) {
        try {
          const parsedAttributes = JSON.parse(storedAttributes);

          if (Array.isArray(parsedAttributes)) {
            // Фильтруем VK токены из атрибутов
            const filteredAttributes = parsedAttributes.filter((attr) => {
              if (attr && attr.value && attr.value.startsWith('vk2.a.')) {
                return false;
              }
              return true;
            });

            this.marketingProgramAttributes = filteredAttributes;

            // Если были удалены VK токены, обновляем localStorage
            if (filteredAttributes.length !== parsedAttributes.length) {
              if (filteredAttributes.length > 0) {
                localStorage.setItem('authAttributes', JSON.stringify(filteredAttributes));
              } else {
                localStorage.removeItem('authAttributes');
              }
            }
          }
        } catch (error) {
          // Игнорируем ошибки парсинга
        }
      }

      if (marketingProgramCode && !marketingProgramCode.startsWith('vk2.a.')) {
        return this.getCodeDetails({ code: marketingProgramCode })
          .then(() => {
            const codeAttributes = this.codeDetails?.code?.attributes || [];

            // Объединяем атрибуты из кода с уже существующими
            this.marketingProgramAttributes = this.mergeAttributes(this.marketingProgramAttributes, codeAttributes);

            // Если атрибуты пустые, добавляем marketingProgramCode как атрибут (но не VK токен)
            if (this.marketingProgramAttributes.length === 0 && marketingProgramCode && !marketingProgramCode.startsWith('vk2.a.')) {
              this.marketingProgramAttributes.push({ key: 'Code', value: marketingProgramCode });
            }

            // Убираем дублирование: если есть InvitationCode, удаляем Code
            const hasInvitationCode = this.marketingProgramAttributes.some((attr) => attr.key === 'InvitationCode');
            if (hasInvitationCode) {
              this.marketingProgramAttributes = this.marketingProgramAttributes.filter((attr) => attr.key !== 'Code');
            }

            const teamId = this.marketingProgramAttributes.find((i) => i.key === 'TeamId');
            if (teamId) {
              this.teamId = teamId.value;
            } else if (invitationTeamId) {
              this.marketingProgramAttributes.push({ key: 'TeamId', value: invitationTeamId });
              this.teamId = invitationTeamId;
            }

            // Сохраняем обновленные атрибуты в localStorage
            if (this.marketingProgramAttributes.length > 0) {
              localStorage.setItem('authAttributes', JSON.stringify(this.marketingProgramAttributes));
            }
          });
      }
      if (invitationTeamId) {
        // Проверяем, есть ли уже TeamId в атрибутах
        const existingTeamId = this.marketingProgramAttributes.find((i) => i.key === 'TeamId');
        if (!existingTeamId) {
          this.marketingProgramAttributes.push({ key: 'TeamId', value: invitationTeamId });
        }
        this.teamId = invitationTeamId;

        // Сохраняем обновленные атрибуты в localStorage
        if (this.marketingProgramAttributes.length > 0) {
          localStorage.setItem('authAttributes', JSON.stringify(this.marketingProgramAttributes));
        }

        return Promise.resolve();
      }
      if (invitationCode) {
        // Проверяем, есть ли уже Code в атрибутах
        const existingCode = this.marketingProgramAttributes.find((i) => i.key === 'Code');
        if (!existingCode) {
          this.marketingProgramAttributes.push({ key: 'Code', value: invitationCode });
        }
        this.teamId = invitationCode;

        // Сохраняем обновленные атрибуты в localStorage
        if (this.marketingProgramAttributes.length > 0) {
          localStorage.setItem('authAttributes', JSON.stringify(this.marketingProgramAttributes));
        }

        return Promise.resolve();
      }

      // Фильтруем VK токены перед сохранением
      const finalAttributes = this.marketingProgramAttributes.filter((attr) => {
        if (attr && attr.value && attr.value.startsWith('vk2.a.')) {
          return false;
        }
        return true;
      });

      // Сохраняем обновленные атрибуты в localStorage
      if (finalAttributes.length > 0) {
        localStorage.setItem('authAttributes', JSON.stringify(finalAttributes));
      } else {
        localStorage.removeItem('authAttributes');
      }

      return Promise.resolve();
    },

    // Установка атрибутов для Yandex SSO (без вызова getCodeDetails)
    setYandexProgramAttributes() {
      // Очищаем старые атрибуты с Code из localStorage
      const storedAttributes = localStorage.getItem('authAttributes');
      if (storedAttributes) {
        try {
          const parsedAttributes = JSON.parse(storedAttributes);
          if (Array.isArray(parsedAttributes)) {
            const hasCode = parsedAttributes.some((attr) => attr.key === 'Code');
            const hasInvitationCode = parsedAttributes.some((attr) => attr.key === 'InvitationCode');
            // Если есть и Code и InvitationCode, удаляем Code
            if (hasCode && hasInvitationCode) {
              const filteredAttributes = parsedAttributes.filter((attr) => attr.key !== 'Code');
              if (filteredAttributes.length > 0) {
                localStorage.setItem('authAttributes', JSON.stringify(filteredAttributes));
              } else {
                localStorage.removeItem('authAttributes');
              }
            }
          }
        } catch (error) {
          // Игнорируем ошибки очистки
        }
      }

      // Проверяем marketingProgramCode в sessionStorage и localStorage
      const sessionMarketingCode = sessionStorage.getItem('marketingProgramCode');
      const localMarketingCode = localStorage.getItem('marketingProgramCode');

      const marketingProgramCode = sessionMarketingCode || localMarketingCode;
      const invitationTeamId = sessionStorage.getItem('invitationTeamId');
      const invitationCode = sessionStorage.getItem('invitationCode');

      // Инициализируем массив атрибутов
      this.marketingProgramAttributes = [];

      // Проверяем, что marketingProgramCode не является VK токеном
      if (marketingProgramCode && marketingProgramCode.startsWith('vk2.a.')) {
        return Promise.resolve();
      }

      // Добавляем атрибуты из localStorage если есть
      if (storedAttributes) {
        try {
          const parsedAttributes = JSON.parse(storedAttributes);
          if (Array.isArray(parsedAttributes)) {
            this.marketingProgramAttributes = [...parsedAttributes];
          }
        } catch (error) {
          // Игнорируем ошибки парсинга
        }
      }

      // Если есть marketingProgramCode, добавляем его как атрибут (без API вызова)
      if (marketingProgramCode) {
        this.marketingProgramAttributes.push({ key: 'Code', value: marketingProgramCode });
      }

      if (invitationTeamId) {
        const existingTeamId = this.marketingProgramAttributes.find((i) => i.key === 'TeamId');
        if (!existingTeamId) {
          this.marketingProgramAttributes.push({ key: 'TeamId', value: invitationTeamId });
        }
        this.teamId = invitationTeamId;
      }

      if (invitationCode) {
        // Проверяем, есть ли уже Code в атрибутах
        const existingCode = this.marketingProgramAttributes.find((i) => i.key === 'Code');
        if (!existingCode) {
          this.marketingProgramAttributes.push({ key: 'Code', value: invitationCode });
        }
        this.teamId = invitationCode;
      }

      // Фильтруем VK токены перед сохранением
      const finalAttributes = this.marketingProgramAttributes.filter((attr) => {
        if (attr && attr.value && attr.value.startsWith('vk2.a.')) {
          return false;
        }
        return true;
      });

      // Сохраняем обновленные атрибуты в localStorage
      if (finalAttributes.length > 0) {
        localStorage.setItem('authAttributes', JSON.stringify(finalAttributes));
      } else {
        localStorage.removeItem('authAttributes');
      }

      return Promise.resolve();
    },

    // Вспомогательный метод для объединения атрибутов без дублирования
    mergeAttributes(existingAttributes, newAttributes) {
      const merged = [...existingAttributes];

      newAttributes.forEach((newAttr) => {
        const existingIndex = merged.findIndex((attr) => attr.key === newAttr.key);
        if (existingIndex >= 0) {
          // Если атрибут уже существует, обновляем его значение
          merged[existingIndex] = newAttr;
        } else {
          // Если атрибута нет, добавляем его
          merged.push(newAttr);
        }
      });

      return merged;
    },

    // Универсальный геттер для authData (объект или массив { key, value })
    getAuthDataValue(authData, key, fallback = null) {
      if (!authData) return fallback;
      if (Array.isArray(authData)) {
        const found = authData.find((i) => i && (i.key === key || i.Key === key));
        if (found) return (found.value !== undefined ? found.value : found.Value) ?? fallback;
        return fallback;
      }
      if (typeof authData === 'object') {
        return authData[key] ?? fallback;
      }
      return fallback;
    },

    checkProfile() {
      this.getProfile()
        .then(() => {
          if (this.isAuthenticated) {
            this.removeAuthFromStorage();
            if (this.emptyProfile === true) {
              this.$router.push({ name: 'Register' }).catch(() => {});
              return;
            }
            if (this.loginReturnUrl) {
              window.location.href = this.loginReturnUrl;
              return;
            }
            if (this.isClubEnabled) {
              this.$router.push({ name: 'Club' }).catch(() => {});
            } else {
              this.$router.push({ name: 'Dashboard' }).catch(() => {});
            }
          }
        });
    },

    updateCountdown() {
      if (this.extendedAuthStep !== 'code-required') return;
      const countdown = getCountdown(this.startDate, false);
      if (!countdown.finished) {
        setTimeout(() => { this.updateCountdown(); }, 1000);
      }
      this.countdown = countdown.values;
    },
    setFocusToEmail() {
      setTimeout(() => {
        const input = document.getElementById('login-email');
        if (!input) return;
        input.focus();
      }, 500);
    },
    isEmailValid(email) {
      if (!email) return false;

      // Базовая проверка формата email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        return false;
      }

      // Проверка длины
      if (email.length > 254) {
        return false;
      }

      // Проверка на пробелы
      if (email.includes(' ')) {
        return false;
      }

      return true;
    },

    isDomainAcceptable(email) {
      if (!email) return true;
      const index = email.indexOf('@');
      if (index < 0 || index === email.length - 1) return true;
      if (this.emailFilters.length === 0) return true;
      const domain = email.slice(index + 1);
      if (this.emailFilters.includes(domain.toLowerCase())) return true;
      return false;
    },
    removeAuthFromStorage() {
      localStorage.removeItem('authAttributes');
    },
    showSupport(hash) {
      if (hash[1] === 'true') this.supportModal = true;
      else {
        this.supportModal = false;
        this.clearHash();
      }
    },
    showSuccess(hash) {
      if (hash[1] === 'true') this.successModal = true;
      else {
        this.successModal = false;
        this.clearHash();
      }
    },
    clearHash() {
      setTimeout(() => { window.location.hash = ''; }, 100);
    },
    setInputs() {
      for (let i = 0; i < 4; i += 1) {
        const current = document.getElementById(`login-auth-code${i}`);
        if (!current) continue;
        current.setAttribute('minlength', '1');
        current.setAttribute('maxlength', '1');
        current.setAttribute('min', '0');
        current.setAttribute('max', '9');
        current.addEventListener('click', () => { current.focus(); });
        if (i === 0) {
          current.setAttribute('autofocus', '');
          current.setAttribute('tabstop', '0');
          current.click();
        }
      }
    },

    // Методы для обработки extended authentication
    handleAuthError(status, errorData = null) {
      let errorCode = null;
      if (errorData && typeof errorData === 'object') {
        errorCode = errorData.code || (Array.isArray(errorData.errors) ? errorData.errors[0]?.code : null) || null;
      }

      // Сбрасываем все состояния ошибок
      this.emailBlocked = false;
      this.domainError = false;
      this.codeError = false;
      this.teamNoInvitation = false;
      this.noInvitation = false;
      this.teamOffLimits = false;
      this.vkAuthenticationFailed = false;
      this.extendedAuthError = null;

      if (status === 409) {
        this.emailBlocked = true;
      } else if (status === 422) {
        if (errorCode === 'user_is_blocked') {
          this.emailBlocked = true;
        } else if (errorCode === 'email_invalid') {
          this.domainError = true;
          this.extendedAuthError = 'Введите Вашу корпоративную почту';
        } else if (errorCode === 'invalid_code') {
          this.domainError = false;
          this.codeError = true;
          this.extendedAuthError = null;
        } else if (errorCode === 'invitation_required') {
          this.teamNoInvitation = true;
        } else if (errorCode === 'invitation_closed_required') {
          this.noInvitation = true;
        } else if (errorCode === 'team_is_completed') {
          this.teamOffLimits = true;
        } else if (errorCode === 'team_not_found') {
          this.teamOffLimits = true;
        } else if (errorCode === 'vk_authentication_failed') {
          this.vkAuthenticationFailed = true;
          this.extendedAuthError = 'Пользователь с данным VK аккаунтом уже зарегистрирован с другим email адресом';
        } else {
          this.extendedAuthError = 'Произошла ошибка при обработке заявки';
        }
      } else {
        this.extendedAuthError = 'Произошла ошибка при обработке заявки';
      }
      this.sending = false;
      this.sendingCode = false;

      // Если мы на странице VK SSO и есть ошибка, переходим на страницу логина
      if (this.$route.path === '/vksso' && (this.noInvitation || this.teamOffLimits || this.emailBlocked || this.teamNoInvitation || this.domainError || this.vkAuthenticationFailed || this.extendedAuthError)) {
        // Сохраняем состояние ошибки в sessionStorage
        if (this.noInvitation) {
          sessionStorage.setItem('showNoInvitationModal', 'true');
        }
        if (this.teamOffLimits) {
          sessionStorage.setItem('showTeamOffLimitsModal', 'true');
        }
        if (this.emailBlocked) {
          sessionStorage.setItem('showEmailBlockedModal', 'true');
        }
        if (this.teamNoInvitation) {
          sessionStorage.setItem('showTeamNoInvitationModal', 'true');
        }
        if (this.domainError) {
          sessionStorage.setItem('showDomainErrorModal', 'true');
        }
        if (this.vkAuthenticationFailed) {
          sessionStorage.setItem('showVkAuthenticationFailedModal', 'true');
        }
        if (this.extendedAuthError) {
          sessionStorage.setItem('showExtendedAuthError', this.extendedAuthError);
        }

        this.$router.replace('/auth').catch(() => {});
      }
    },

    handleProcessError(errorData = null) {
      // Используем переданные данные или данные из store
      const data = errorData || this.extendedAuthProcessResult || null;
      // Убеждаемся, что статус установлен
      const status = this.extendedAuthProcessStatus || 0;
      this.handleAuthError(status, data);
    },

    handleCreateRequestError() {
      this.handleAuthError(this.extendedAuthRequestStatus, this.extendedAuthRequest);
    },

    handleChangeEmailError() {
      this.handleAuthError(this.extendedAuthChangeEmailStatus, this.extendedAuthChangeEmailResult);
    },

    handleSubmitCodeError() {
      // Убеждаемся, что статус установлен и данные передаются
      const status = this.extendedAuthSubmitCodeStatus || 0;
      const data = this.extendedAuthSubmitCodeResult || null;
      this.handleAuthError(status, data);
    },

    handleAuthSuccess() {
      // Сохраняем токен доступа
      const accessToken = this.extendedAuthProcessResult?.accessToken;
      if (accessToken) {
        Cookies.set('token', accessToken, { expires: 365 });
        this.setAccessToken(accessToken);
        this.setAuthenticated(true);
      }

      this.extendedAuthStep = 'success';
      this.sending = false;

      // Переходим к профилю или регистрации
      this.checkProfile();
    },
    // Валидация кода
    validateCode() {
      const codeString = this.code.join('');
      if (codeString.length !== 4) {
        this.codeError = true;
        return null;
      }
      return codeString;
    },

    // Отправка кода
    async submitCodeForValidation(codeString) {
      await this.submitCode({
        token: this.extendedAuthToken,
        code: codeString,
      });

      if (this.extendedAuthSubmitCodeStatus !== 200) {
        this.handleSubmitCodeError();
        throw new Error('Submit code failed');
      }

      const result = this.extendedAuthSubmitCodeResult?.result;
      if (result !== 'EmailApproved') {
        this.extendedAuthError = `Неожиданный результат: ${result}`;
        this.sendingCode = false;
        throw new Error('Unexpected result');
      }

      return result;
    },

    // Обработка после отправки кода
    async processAfterCodeSubmission() {
      try {
        await this.processAuthRequest({ token: this.extendedAuthToken });
      } catch (error) {
        // Продолжаем обработку
      }

      if (this.extendedAuthProcessStatus !== 200) {
        this.handleProcessError();
        throw new Error('Process error');
      }

      const finalResult = this.extendedAuthProcessResult?.result;
      if (finalResult !== 'Success') {
        this.extendedAuthError = `Неожиданный результат: ${finalResult}`;
        this.sendingCode = false;
        throw new Error('Unexpected result');
      }

      return finalResult;
    },

    // Сохранение VK атрибутов для предзаполнения анкеты
    saveVKAttributesForRegistration(accessToken) {
      try {
        const isVKFlow = sessionStorage.getItem('vkAuth') === 'true';

        if (isVKFlow) {
          // Получаем существующие атрибуты из sessionStorage (сохраненные в handleEmailRequired)
          let attrs = [];
          try {
            const storedAttributes = sessionStorage.getItem('ssoAccessAttributes');
            if (storedAttributes) {
              attrs = JSON.parse(storedAttributes);
            }
          } catch (e) {
            // Игнорируем ошибки парсинга
          }

          // Если нет сохраненных атрибутов, берем из результата процесса
          if (!Array.isArray(attrs) || attrs.length === 0) {
            attrs = Array.isArray(this.extendedAuthProcessResult?.attributes)
              ? [...this.extendedAuthProcessResult.attributes]
              : [];
          }

          // Добавляем email из JWT токена, если его еще нет
          const emailFromJwt = this.extractEmailFromJwt(accessToken);

          if (emailFromJwt) {
            const existingEmail = attrs.find((attr) => attr.key === 'EmailAddress' || attr.key === 'email');
            if (!existingEmail) {
              attrs.push({ key: 'EmailAddress', value: emailFromJwt });
            } else {
              // Обновляем существующий email
              existingEmail.value = emailFromJwt;
            }
          }

          sessionStorage.setItem('authFromSSO', 'true');
          sessionStorage.setItem('ssoAccessAttributes', JSON.stringify(attrs));
        }
      } catch (e) {
        // Игнорируем ошибки
      }
    },

    // Обработка успешной авторизации
    handleSuccessfulAuth() {
      const accessToken = this.extendedAuthProcessResult?.accessToken;

      if (accessToken) {
        Cookies.set('token', accessToken, { expires: 365 });
        this.setAccessToken(accessToken);
        this.setAuthenticated(true);
      }

      // Если это VK-поток (после ввода кода e-mail), сохраняем атрибуты для предзаполнения анкеты
      this.saveVKAttributesForRegistration(accessToken);

      // Переходим к профилю (дальше логика отправит на Register при пустом профиле)
      this.checkProfile();
    },

    // Обработка ошибок в onCodeSubmit
    handleCodeSubmitError() {
      if (this.extendedAuthProcessStatus && this.extendedAuthProcessStatus !== 200) {
        this.handleProcessError();
      } else {
        this.handleSubmitCodeError();
      }
    },

    async onCodeSubmit() {
      // Валидация кода
      const codeString = this.validateCode();
      if (!codeString) {
        return;
      }

      this.sendingCode = true;
      this.codeError = false;
      this.extendedAuthError = null;

      try {
        // Отправляем код
        await this.submitCodeForValidation(codeString);

        // Обрабатываем результат
        await this.processAfterCodeSubmission();

        // Обрабатываем успешную авторизацию
        this.handleSuccessfulAuth();
      } catch (error) {
        this.handleCodeSubmitError();
      }
    },
    onCancelAuth() {
      if (this.extendedAuthToken) {
        this.cancelAuthRequest({ token: this.extendedAuthToken })
          .catch(() => {
          // Игнорируем ошибки при отмене
          });
      }

      this.resetExtendedAuth();
    },
    resetExtendedAuth() {
      this.extendedAuthToken = null;
      this.extendedAuthStep = 'start';
      this.extendedAuthResult = null;
      this.extendedAuthError = null;
      this.email = null;
      this.code = ['', '', '', ''];
      this.sending = false;
      this.sendingCode = false;
      this.codeError = false;
      this.emailError = false;
      this.showInvalidCodeMessage = true; // Восстанавливаем показ сообщения
      this.marketingProgramAttributes = [];
    },

    // Методы для закрытия модалок
    onTeamOffLimitsClose() {
      this.resetToInitialState();
    },

    onNoInvitationClose() {
      this.resetToInitialState();
    },

    onTeamNoInvitationClose() {
      this.resetToInitialState();
    },

    // Сброс к начальному состоянию
    resetToInitialState() {
      this.removeAuthFromStorage();
      this.resetExtendedAuth();
      this.teamOffLimits = false;
      this.noInvitation = false;
      this.teamNoInvitation = false;
      this.emailBlocked = false;

      // Очищаем данные модальных окон из storage
      sessionStorage.removeItem('showNoInvitationModal');
      sessionStorage.removeItem('showTeamOffLimitsModal');
      sessionStorage.removeItem('showEmailBlockedModal');
      sessionStorage.removeItem('showTeamNoInvitationModal');
      sessionStorage.removeItem('showDomainErrorModal');
      sessionStorage.removeItem('showExtendedAuthError');

      this.$router.replace('/auth').catch(() => {});
    },

    // Методы для генерации PKCE параметров
    generateCodeVerifier() {
      const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
      let result = '';
      for (let i = 0; i < 64; i += 1) {
        result += charset.charAt(Math.floor(Math.random() * charset.length));
      }
      return result;
    },

    generateCodeChallenge(codeVerifier) {
      // Правильная реализация PKCE code_challenge согласно RFC 7636
      // Используем Web Crypto API для SHA256
      if (window.crypto && window.crypto.subtle) {
        // Асинхронная версия с Web Crypto API
        return this.generateCodeChallengeAsync(codeVerifier);
      }
      // Fallback для старых браузеров - используем упрощенную реализацию
      return this.generateCodeChallengeFallback(codeVerifier);
    },

    async generateCodeChallengeAsync(codeVerifier) {
      try {
        const encoder = new TextEncoder();
        const data = encoder.encode(codeVerifier);
        const digest = await window.crypto.subtle.digest('SHA-256', data);
        const base64 = btoa(String.fromCharCode(...new Uint8Array(digest)));
        return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
      } catch (error) {
        return this.generateCodeChallengeFallback(codeVerifier);
      }
    },

    generateCodeChallengeFallback(codeVerifier) {
      // Упрощенная реализация для старых браузеров
      // В реальном проекте лучше использовать библиотеку для SHA256
      let hash = 0;
      for (let i = 0; i < codeVerifier.length; i += 1) {
        const char = codeVerifier.charCodeAt(i);
        hash = hash * 31 + char;
        hash %= 0x7fffffff; // Convert to 32bit integer
      }

      // Простое base64url кодирование
      const base64 = btoa(hash.toString());
      return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    },

    generateState() {
      return Math.random().toString(36).substring(2, 15)
        + Math.random().toString(36).substring(2, 15);
    },

    extractEmailFromJwt(token) {
      try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const decoded = atob(base64);
        const jsonPayload = Array.from(decoded).map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join('');
        const payload = JSON.parse(decodeURIComponent(jsonPayload));
        return payload.EmailAddress || payload.email || null;
      } catch (e) {
        return null;
      }
    },

    // Инициализация VK email после возврата
    initializeVKEmailRequired() {
      this.extendedAuthStep = 'email-required';
      // скрыть ошибки и кнопки SSO; оставить только email форму
      this.ssoError = false;
      this.vkError = false;
      this.email = '';
      this.sending = false;
      // восстановим токен заявки
      const storedToken = sessionStorage.getItem('extendedAuthToken');
      if (storedToken) this.extendedAuthToken = storedToken;
      // фокус на поле email
      this.setFocusToEmail();
    },

    // Инициализация заблокированного логина
    initializeLoginBlocked() {
      this.email = this.showLoginBlocked === 'true' ? '' : this.showLoginBlocked;
      this.emailBlocked = true;
    },

    // Инициализация авторизации
    async initializeAuthentication() {
      await this.getProvidersAuth();
      this.getRule();

      // Если это не возврат из SSO и нет активной заявки, убираем залипшие флаги email-required
      if (!this.isAuthSSO) {
        const hasFlags = this.$route.query
          && (this.$route.query.vkEmailRequired === '1' || this.$route.query.yandexEmailRequired === '1');
        const hasToken = !!sessionStorage.getItem('extendedAuthToken');
        if (hasFlags && !hasToken) {
          this.clearEmailRequiredQueryFlags();
        }
      }

      if (this.isAuthSSO) {
        // Завершаем Extended Auth SSO на любом роуте
        const result = await this.authSSOExtendedReturn();
        return result;
      }

      // VK: если требуется указать e‑mail после возврата
      if (this.$route.query && this.$route.query.vkEmailRequired === '1') {
        this.initializeVKEmailRequired();
        return Promise.resolve();
      }

      if (this.showLoginBlocked) {
        this.initializeLoginBlocked();
        return Promise.resolve();
      }

      this.setFocusToEmail();
      return Promise.resolve();
    },

    // Инициализация компонента
    initializeComponent() {
      window.addEventListener('hashchange', this.onHashChange);
      this.onHashChange();
      this.initializeAuthentication().then(() => {
        // Инициализация завершена
      }).catch(() => {
        // Обработка ошибок инициализации
      });
    },
  },
  mounted() {
    // Восстанавливаем состояние модальных окон из sessionStorage
    if (sessionStorage.getItem('showNoInvitationModal') === 'true') {
      this.noInvitation = true;
      sessionStorage.removeItem('showNoInvitationModal');
    }
    if (sessionStorage.getItem('showTeamOffLimitsModal') === 'true') {
      this.teamOffLimits = true;
      sessionStorage.removeItem('showTeamOffLimitsModal');
    }
    if (sessionStorage.getItem('showEmailBlockedModal') === 'true') {
      this.emailBlocked = true;
      sessionStorage.removeItem('showEmailBlockedModal');
    }
    if (sessionStorage.getItem('showTeamNoInvitationModal') === 'true') {
      this.teamNoInvitation = true;
      sessionStorage.removeItem('showTeamNoInvitationModal');
    }
    if (sessionStorage.getItem('showDomainErrorModal') === 'true') {
      this.domainError = true;
      sessionStorage.removeItem('showDomainErrorModal');
    }
    if (sessionStorage.getItem('showVkAuthenticationFailedModal') === 'true') {
      this.vkAuthenticationFailed = true;
      sessionStorage.removeItem('showVkAuthenticationFailedModal');
    }
    const storedExtendedAuthError = sessionStorage.getItem('showExtendedAuthError');
    if (storedExtendedAuthError) {
      this.extendedAuthError = storedExtendedAuthError;
      sessionStorage.removeItem('showExtendedAuthError');
    }

    this.initializeComponent();
  },
  beforeDestroy() {
    window.removeEventListener('hashchange', this.onHashChange);
  },
};
</script>

<style lang="scss" scoped>
  @import "./Login";
</style>
